import { Button } from "../components/ui/button";
import { Mail, MapPin, Phone } from "lucide-react";

export function Contact() {
  return (
    <div className="container py-16 md:py-24">
      <div className="grid lg:grid-cols-2 gap-16">
        {/* Contact Info */}
        <div className="space-y-8">
          <div>
            <h1 className="text-4xl font-heading font-bold text-text-title mb-4">Contattaci</h1>
            <p className="text-lg text-text-body">
              Siamo qui per rispondere a tutte le tue domande. Compila il form o utilizza i recapiti qui sotto per parlare con noi.
            </p>
          </div>

          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="bg-brand-primary/10 p-3 rounded-lg text-brand-primary">
                <MapPin className="h-6 w-6" />
              </div>
              <div>
                <h3 className="font-bold text-text-title mb-1">Le Nostre Sedi</h3>
                <p className="text-text-body">Via Nickmann 19, Bari</p>
                <p className="text-text-body">Via Metaponto, Contrada Paludi, Taranto</p>
                <p className="text-text-body">Via Antonio Murri 6, Mesagne (Br)</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-brand-primary/10 p-3 rounded-lg text-brand-primary">
                <Phone className="h-6 w-6" />
              </div>
              <div>
                <h3 className="font-bold text-text-title mb-1">Telefono</h3>
                <p className="text-text-body mb-1">Assistenza Clienti:</p>
                <a href="tel:800290361" className="text-brand-secondary font-bold hover:underline block text-lg mb-1">
                  Numero Verde: 800 290 361
                </a>
                <a href="tel:+390805378955" className="text-brand-primary font-medium hover:underline block">
                  +39 080 537 8955 (Bari - Sede Principale)
                </a>
                <a href="tel:+390994711826" className="text-brand-primary font-medium hover:underline block">
                  +39 099 471 1826 (Taranto)
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-brand-primary/10 p-3 rounded-lg text-brand-primary">
                <Mail className="h-6 w-6" />
              </div>
              <div>
                <h3 className="font-bold text-text-title mb-1">Email</h3>
                <a href="mailto:info@puglialifesrl.it" className="text-brand-primary font-medium hover:underline">
                  info@puglialifesrl.it
                </a>
              </div>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="aspect-video bg-gray-100 rounded-xl overflow-hidden shadow-inner border relative">
            <div className="absolute inset-0 flex items-center justify-center text-gray-400">
              <span className="flex items-center gap-2">
                <MapPin className="h-5 w-5" /> Mappa interattiva
              </span>
            </div>
            {/* If we had a real map API key, we would put the iframe here */}
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3019.268069566914!2d17.2764!3d40.4578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI3JzI4LjEiTiAxN8KwMTYnMzUuMCJF!5e0!3m2!1sit!2sit!4v1620000000000!5m2!1sit!2sit" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy" 
              title="Mappa sedi Puglia Life"
            ></iframe>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white p-8 rounded-2xl shadow-lg border">
          <h2 className="text-2xl font-heading font-bold text-text-title mb-6">Inviaci un messaggio</h2>
          <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
            <div className="space-y-2">
              <label htmlFor="name" className="text-sm font-medium text-text-body block">
                Nome e Cognome <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                required
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                placeholder="Mario Rossi"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label htmlFor="email" className="text-sm font-medium text-text-body block">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  placeholder="mario@email.com"
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="phone" className="text-sm font-medium text-text-body block">
                  Telefono
                </label>
                <input
                  type="tel"
                  id="phone"
                  className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  placeholder="+39 333 1234567"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label htmlFor="service" className="text-sm font-medium text-text-body block">
                Servizio di interesse
              </label>
              <select
                id="service"
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-text-body focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent bg-white"
              >
                <option value="">Seleziona un servizio...</option>
                <option value="ossigenoterapia">Ossigenoterapia</option>
                <option value="ventiloterapia">Ventiloterapia</option>
                <option value="sonno">Disturbi del Sonno</option>
                <option value="nutrizione">Nutrizione</option>
                <option value="altro">Altro</option>
              </select>
            </div>

            <div className="space-y-2">
              <label htmlFor="message" className="text-sm font-medium text-text-body block">
                Messaggio <span className="text-red-500">*</span>
              </label>
              <textarea
                id="message"
                required
                rows={5}
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent resize-none"
                placeholder="Come possiamo aiutarti?"
              ></textarea>
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="privacy"
                required
                className="h-4 w-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary"
              />
              <label htmlFor="privacy" className="text-sm text-text-body">
                Ho letto e accetto la{" "}
                <a
                  href="/privacy"
                  className="text-brand-primary underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 rounded-sm"
                >
                  Privacy Policy
                </a>
              </label>
            </div>

            <Button type="submit" className="w-full md:w-auto" size="lg">
              Invia Messaggio
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
